module.exports = __webpack_public_path__ + "static/media/check-round.841f5af4.svg";